// AUTO-GENERATED CODE, DO NOT EDIT!
//
// These types are generated from the schema
// base types and should not be used
//
/* eslint-disable */

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** Represents untyped JSON */
  JSON: any;
};

export type AuthenticateGuestInput = {
  email: Scalars["String"];
  password: Scalars["String"];
};

export type Avatar = {
  __typename?: "Avatar";
  normal?: Maybe<Scalars["String"]>;
  small?: Maybe<Scalars["String"]>;
  thumb?: Maybe<Scalars["String"]>;
};

/** Type of a normal brief. */
export type Brief = {
  __typename?: "Brief";
  additionalNotes?: Maybe<Scalars["String"]>;
  budget: Scalars["Float"];
  capacities: Scalars["Int"];
  /** Archived */
  catering?: Maybe<Array<Scalars["String"]>>;
  cateringNeeds?: Maybe<Scalars["String"]>;
  collection: Scalars["JSON"];
  collectionName: Scalars["String"];
  country?: Maybe<Scalars["String"]>;
  createdAt: Scalars["String"];
  currency: Scalars["String"];
  /** Deal ID on Hubspot */
  dealId?: Maybe<Scalars["String"]>;
  /** Event From (Full DateTime) */
  eventDateFrom: Scalars["String"];
  /** Event To (Full DateTime) */
  eventDateTo: Scalars["String"];
  eventName: Scalars["String"];
  flexibleDates: Scalars["Boolean"];
  flexibleDatesNote?: Maybe<Scalars["String"]>;
  fromDate: Scalars["String"];
  fromTime: Scalars["String"];
  guest: BriefGuest;
  /** Guest (User) ID */
  guestId: Scalars["ID"];
  /** Host (User) ID */
  hostId?: Maybe<Scalars["ID"]>;
  id: Scalars["ID"];
  lat: Scalars["Float"];
  layout: Scalars["String"];
  leadFeedCity?: Maybe<Scalars["String"]>;
  lfAccessSecret?: Maybe<Scalars["String"]>;
  location: Scalars["String"];
  lon: Scalars["Float"];
  public: Scalars["Boolean"];
  radius: Scalars["Float"];
  /** List of Space Facilities */
  spaceFacilities: Array<SpaceFacility>;
  spaceId?: Maybe<Scalars["ID"]>;
  status: Scalars["String"];
  styleIds: Array<Scalars["String"]>;
  tier: Scalars["String"];
  toDate: Scalars["String"];
  toTime: Scalars["String"];
  /** Guest (User) ID */
  userId: Scalars["ID"];
  virtual: Scalars["Boolean"];
};

/**
 * Attributes for creating or updating a brief.
 *     Also means what we get from BriefBuidler FrontEnd.
 */
export type BriefAttributes = {
  additionalNotes?: InputMaybe<Scalars["String"]>;
  budget: Scalars["Int"];
  bypassAutomation?: InputMaybe<Scalars["Boolean"]>;
  capacities: Scalars["Int"];
  catering?: InputMaybe<Array<Scalars["String"]>>;
  cateringNeeds?: InputMaybe<Scalars["String"]>;
  collection?: InputMaybe<Scalars["String"]>;
  collectionName?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  currency?: InputMaybe<Scalars["String"]>;
  eventName?: InputMaybe<Scalars["String"]>;
  /** Deprecated: use spaceFacilityIds instead. */
  facilities?: InputMaybe<Array<Scalars["String"]>>;
  /** Deprecated: use spaceFacilityIds instead. */
  facilitiesList?: InputMaybe<Array<Scalars["String"]>>;
  flexibleDates?: InputMaybe<Scalars["Boolean"]>;
  flexibleDatesNote?: InputMaybe<Scalars["String"]>;
  fromDate?: InputMaybe<Scalars["String"]>;
  fromTime?: InputMaybe<Scalars["String"]>;
  hostId?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["Int"]>;
  lat: Scalars["String"];
  layouts?: InputMaybe<Scalars["String"]>;
  leadFeedCity?: InputMaybe<Scalars["String"]>;
  location: Scalars["String"];
  lon: Scalars["String"];
  public?: InputMaybe<Scalars["Boolean"]>;
  radius?: InputMaybe<Scalars["Float"]>;
  spaceFacilityIds?: InputMaybe<Array<Scalars["Int"]>>;
  spaceId?: InputMaybe<Scalars["String"]>;
  styleIds?: InputMaybe<Array<Scalars["String"]>>;
  tier?: InputMaybe<Scalars["String"]>;
  toDate?: InputMaybe<Scalars["String"]>;
  toTime?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["Int"]>;
  virtual?: InputMaybe<Scalars["Boolean"]>;
};

/** Type of a guest user who created the brief. */
export type BriefGuest = {
  __typename?: "BriefGuest";
  company: Scalars["String"];
  country?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  firstName: Scalars["String"];
  id: Scalars["ID"];
  isBusinessUser: Scalars["Boolean"];
  lastName: Scalars["String"];
  mobileNumber?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
};

export type BriefIsAutomatableResponse = {
  __typename?: "BriefIsAutomatableResponse";
  /** Whether the brief is automatable. */
  isAutomatable: Scalars["Boolean"];
};

export type BriefLatLon = {
  lat: Scalars["Float"];
  lon: Scalars["Float"];
};

/** Type of collection / event_type. */
export type Collection = {
  __typename?: "Collection";
  features?: Maybe<Array<Feature>>;
  id: Scalars["ID"];
  label?: Maybe<Scalars["String"]>;
  layouts?: Maybe<Array<Scalars["String"]>>;
  name: Scalars["String"];
};

export type Company = {
  __typename?: "Company";
  ID: Scalars["Int"];
  id?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

export type CostItemQtyIn = {
  ID: Scalars["Int"];
  quantity: Scalars["Int"];
};

export type CreateAccountUserDetailsInput = {
  contactNumber: Scalars["String"];
  country?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  requestsExtraMarketingContent: Scalars["Boolean"];
};

export type CreateBusinessGuestAccountInput = {
  password: Scalars["String"];
  userDetails: CreateAccountUserDetailsInput;
};

export type CreateEventInput = {
  accountManagerId?: InputMaybe<Scalars["Int"]>;
  additionalNotes?: InputMaybe<Scalars["String"]>;
  attendees: Scalars["Int"];
  automatedInvitationsBypassed: Scalars["Boolean"];
  automatedInvitationsQualified: Scalars["Boolean"];
  budget: Scalars["Int"];
  cateringNeeds?: InputMaybe<Scalars["String"]>;
  currency: Scalars["String"];
  eventTypeID: Scalars["Int"];
  flexibleDatesNote: Scalars["String"];
  fromDateTime: Scalars["String"];
  guestCompany: Scalars["String"];
  guestID: Scalars["Int"];
  isFlexibleWithDates: Scalars["Boolean"];
  lat: Scalars["String"];
  layoutID: Scalars["String"];
  location: Scalars["String"];
  lon: Scalars["String"];
  name: Scalars["String"];
  radius: Scalars["String"];
  spaceFacilityIDs: Array<Scalars["Int"]>;
  styleIDs?: InputMaybe<Array<Scalars["String"]>>;
  toDateTime: Scalars["String"];
};

export type CreateEventNoteInput = {
  eventID: Scalars["Int"];
  note: Scalars["String"];
};

export type CreateHostAccountInput = {
  password: Scalars["String"];
  userDetails: CreateAccountUserDetailsInput;
};

export type CreateProposalInput = {
  attendees: Scalars["Int"];
  baseCostDescription: Scalars["String"];
  baseCostTotal: Scalars["Int"];
  currency: Scalars["String"];
  documentFilePaths?: InputMaybe<Array<Scalars["String"]>>;
  eventID: Scalars["Int"];
  extraCostItems?: InputMaybe<Array<ExtraCostItemInput>>;
  fromDateTime: Scalars["String"];
  invitationID: Scalars["Int"];
  message?: InputMaybe<Scalars["String"]>;
  spaceID: Scalars["Int"];
  toDateTime: Scalars["String"];
  venueName: Scalars["String"];
};

export type CreateStandardGuestAccountInput = {
  userDetails: CreateAccountUserDetailsInput;
};

export type DeleteEventNoteInput = {
  ID: Scalars["Int"];
};

export type Event = {
  __typename?: "Event";
  ID: Scalars["Int"];
  UUID: Scalars["ID"];
  accountManager?: Maybe<User>;
  actualEventMgmtFee?: Maybe<Scalars["Int"]>;
  additionalNotes?: Maybe<Scalars["String"]>;
  attendees: Scalars["Int"];
  bookingRequestedAt?: Maybe<Scalars["String"]>;
  bookingRequestedBy?: Maybe<Scalars["Int"]>;
  budget: Scalars["Int"];
  cateringNeeds?: Maybe<Scalars["String"]>;
  commissionPerc?: Maybe<Scalars["Float"]>;
  completedAt?: Maybe<Scalars["String"]>;
  currency: Scalars["String"];
  decisionDate?: Maybe<Scalars["String"]>;
  estimatedEventMgmtFee?: Maybe<Scalars["Int"]>;
  eventType: Collection;
  firstInvitationSentAt?: Maybe<Scalars["String"]>;
  firstProposalReceivedAt?: Maybe<Scalars["String"]>;
  firstProposalsSentToGuestAt?: Maybe<Scalars["String"]>;
  fromDateTime: Scalars["String"];
  guest: User;
  invitations?: Maybe<Array<Invitation>>;
  lat: Scalars["String"];
  layoutID: Scalars["String"];
  location: Scalars["String"];
  lon: Scalars["String"];
  name: Scalars["String"];
  notes?: Maybe<Array<EventNote>>;
  processingFeePerc?: Maybe<Scalars["Float"]>;
  proposalCount: Scalars["Int"];
  proposals: Array<Proposal>;
  radius?: Maybe<Scalars["String"]>;
  releaseReason?: Maybe<EventReleaseReason>;
  requestedToBookAt?: Maybe<Scalars["String"]>;
  spaceFacilities?: Maybe<Array<SpaceFacility>>;
  status: EventStatus;
  styles?: Maybe<Array<Style>>;
  submittedAt: Scalars["String"];
  toDateTime: Scalars["String"];
  updatedAt?: Maybe<Scalars["String"]>;
};

export enum EventActiveArg {
  Active = "Active",
  AllEvents = "AllEvents",
  Inactive = "Inactive",
}

export type EventNote = {
  __typename?: "EventNote";
  ID: Scalars["Int"];
  note: Scalars["String"];
};

export type EventPage = {
  __typename?: "EventPage";
  events: Array<Event>;
  limit: Scalars["Int"];
  offset: Scalars["Int"];
  total: Scalars["Int"];
};

export enum EventReleaseReason {
  BookedDirectly = "BookedDirectly",
  CancelledByBooker = "CancelledByBooker",
  EventCancelled = "EventCancelled",
  EventHeldInternally = "EventHeldInternally",
  ScopingExercise = "ScopingExercise",
}

export type EventSortArg = {
  fromDateTimeAscending?: InputMaybe<Scalars["Boolean"]>;
};

export enum EventStatus {
  AwaitingDecision = "AwaitingDecision",
  Cancelled = "Cancelled",
  Completed = "Completed",
  Created = "Created",
  HostsInvited = "HostsInvited",
  Lost = "Lost",
  NoInvitations = "NoInvitations",
  NoResponseChosen = "NoResponseChosen",
  NoResponses = "NoResponses",
  ProposalsReceived = "ProposalsReceived",
  ProposalsSent = "ProposalsSent",
  RequestedToBook = "RequestedToBook",
}

export type EventsFilter = {
  activeForAdmin?: InputMaybe<Scalars["Boolean"]>;
};

export type ExtraCostItem = {
  __typename?: "ExtraCostItem";
  ID: Scalars["Int"];
  costPerUnit: Scalars["Int"];
  description: Scalars["String"];
  quantity?: Maybe<Scalars["Int"]>;
};

export type ExtraCostItemInput = {
  ID?: InputMaybe<Scalars["Int"]>;
  costPerUnit: Scalars["Int"];
  description: Scalars["String"];
};

export type FacilityCategory = {
  __typename?: "FacilityCategory";
  id?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["Int"]>;
  searchable?: Maybe<Scalars["Boolean"]>;
};

/** Type of features of collection. */
export type Feature = {
  __typename?: "Feature";
  id: Scalars["ID"];
  name: Scalars["String"];
  position: Scalars["Int"];
};

export type FeatureCategory = {
  __typename?: "FeatureCategory";
  id?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["Int"]>;
  searchable?: Maybe<Scalars["Boolean"]>;
};

export type GeolocationFilterInput = {
  latitude: Scalars["Float"];
  longitude: Scalars["Float"];
  radiusMeters: Scalars["Int"];
};

export type GetAllHostsInfoArgs = {
  eventTypeID?: InputMaybe<Scalars["Int"]>;
};

export type GuestType = {
  __typename?: "GuestType";
  hasExistingAccount: Scalars["Boolean"];
  isBusinessUser: Scalars["Boolean"];
  isDomainValid: Scalars["Boolean"];
  userId?: Maybe<Scalars["Int"]>;
};

export type Host = {
  __typename?: "Host";
  email: Scalars["String"];
  id: Scalars["Int"];
  isPowerHost: Scalars["Boolean"];
  isSmartBookHost: Scalars["Boolean"];
};

export type HostContact = {
  __typename?: "HostContact";
  avatar?: Maybe<Avatar>;
  email?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
};

export type HostInfo = {
  __typename?: "HostInfo";
  eventTypes: Array<Scalars["Int"]>;
  hostID: Scalars["Int"];
  isSelfServeHost: Scalars["Boolean"];
  user: User;
  venues: Array<SelfServeVenue>;
};

export type Invitation = {
  __typename?: "Invitation";
  ID: Scalars["Int"];
  createdAt?: Maybe<Scalars["String"]>;
  declinedAt?: Maybe<Scalars["String"]>;
  declinedReason?: Maybe<InvitationDeclinedReason>;
  event: Event;
  proposals?: Maybe<Array<Proposal>>;
  space?: Maybe<SelfServeSpace>;
  venue?: Maybe<SelfServeVenue>;
};

export enum InvitationDeclinedReason {
  CateringRequirements = "CateringRequirements",
  FacilitiesRequirements = "FacilitiesRequirements",
  LowBudget = "LowBudget",
  NoAvailability = "NoAvailability",
  Other = "Other",
}

export type LeadsPage = {
  __typename?: "LeadsPage";
  /** Infomation of this current page. */
  pages: Page;
  /** Rows of AM leads. */
  rows: Array<Brief>;
  /** Total number of pages. */
  totalPages: Scalars["Int"];
  /** Totla number of AM leads. */
  totalRows: Scalars["Int"];
};

export type Mutation = {
  __typename?: "Mutation";
  CreateSpaceSummary?: Maybe<Space>;
  CreateVenue?: Maybe<Venue>;
  DeleteSpace?: Maybe<Space>;
  DeleteSpaceDocument?: Maybe<Scalars["Boolean"]>;
  DeleteSpacePhoto?: Maybe<Scalars["Boolean"]>;
  DeleteVenue?: Maybe<Venue>;
  DuplicateSpace?: Maybe<Space>;
  MoveSpace?: Maybe<Space>;
  PublishSpace?: Maybe<Space>;
  RejectSpace?: Maybe<Space>;
  SubmitSpaceToReview?: Maybe<Space>;
  UnpublishSpace?: Maybe<Space>;
  UpdateCollections?: Maybe<Space>;
  UpdateIsPrivate?: Maybe<Space>;
  UpdateSpaceDocuments?: Maybe<Space>;
  UpdateSpaceFacilities?: Maybe<Space>;
  UpdateSpacePhotos?: Maybe<Space>;
  UpdateSpaceStyles?: Maybe<Space>;
  UpdateSpaceSummary?: Maybe<Space>;
  UpdateSpatialConfiguration?: Maybe<Space>;
  UpdateTour3dUrl?: Maybe<Space>;
  UpdateVenue?: Maybe<Venue>;
  _?: Maybe<Scalars["Boolean"]>;
  authenticateGuest: Session;
  /** Create a new brief by BriefAttributes. */
  brief?: Maybe<Brief>;
  cancelEvent: Event;
  /** Claim a brief by ID. */
  claimBrief?: Maybe<Brief>;
  completeEvent: Event;
  createBusinessGuestAccount: Session;
  createEvent: Event;
  createEventNote: EventNote;
  createHostAccount: Session;
  createProposal: Proposal;
  createStandardGuestAccount: Session;
  declineInvitation: Invitation;
  deleteEventNote: EventNote;
  /** Disqualify a brief by ID. */
  disqualifyBrief?: Maybe<Brief>;
  getProposalDocumentUrl: ProposalSignedUrlData;
  /** Release a brief by ID. */
  releaseBrief?: Maybe<Brief>;
  releaseProposals: Array<Proposal>;
  requestToBook: Proposal;
  /** Resend the brief confirmatio to guest email by ID. */
  resendBriefConfirmation?: Maybe<Brief>;
  /** Resend the claimed brief infomation to Hubspot again by ID. */
  resendBriefToHubspot?: Maybe<Brief>;
  /** Resend the User infomation by ID to Hubspot for creating contact. */
  resendUserToHubspot?: Maybe<User>;
  resetPassword: Scalars["Boolean"];
  sendInvitations: Array<Invitation>;
  triggerPasswordReset: Scalars["Boolean"];
  updateEvent: Event;
  updateHost: HostInfo;
  updatePreferredVenuesForCompany: Array<SelfServeVenue>;
  updateProposal: Proposal;
};

export type MutationCreateSpaceSummaryArgs = {
  spaceSummary: SpaceSummaryInput;
  venueId: Scalars["Int"];
};

export type MutationCreateVenueArgs = {
  venue: VenueInput;
};

export type MutationDeleteSpaceArgs = {
  spaceId: Scalars["Int"];
};

export type MutationDeleteSpaceDocumentArgs = {
  s3Key: Scalars["String"];
  spaceId: Scalars["Int"];
};

export type MutationDeleteSpacePhotoArgs = {
  s3Key: Scalars["String"];
  spaceId: Scalars["Int"];
};

export type MutationDeleteVenueArgs = {
  id: Scalars["Int"];
};

export type MutationDuplicateSpaceArgs = {
  spaceId: Scalars["Int"];
};

export type MutationMoveSpaceArgs = {
  newVenueId: Scalars["Int"];
  spaceId: Scalars["Int"];
};

export type MutationPublishSpaceArgs = {
  spaceId: Scalars["Int"];
};

export type MutationRejectSpaceArgs = {
  spaceId: Scalars["Int"];
};

export type MutationSubmitSpaceToReviewArgs = {
  spaceId: Scalars["Int"];
};

export type MutationUnpublishSpaceArgs = {
  spaceId: Scalars["Int"];
};

export type MutationUpdateCollectionsArgs = {
  collectionIds: Array<InputMaybe<Scalars["Int"]>>;
  spaceId: Scalars["Int"];
};

export type MutationUpdateIsPrivateArgs = {
  isPrivate?: InputMaybe<Scalars["Boolean"]>;
  spaceId: Scalars["Int"];
};

export type MutationUpdateSpaceDocumentsArgs = {
  spaceDocuments: Array<InputMaybe<SpaceDocumentInput>>;
  spaceId: Scalars["Int"];
};

export type MutationUpdateSpaceFacilitiesArgs = {
  spaceFacilityIds: Array<InputMaybe<Scalars["Int"]>>;
  spaceId: Scalars["Int"];
};

export type MutationUpdateSpacePhotosArgs = {
  spaceId: Scalars["Int"];
  spacePhotos: Array<InputMaybe<SpacePhotoInput>>;
};

export type MutationUpdateSpaceStylesArgs = {
  spaceId: Scalars["Int"];
  styleIds: Array<InputMaybe<StyleId>>;
};

export type MutationUpdateSpaceSummaryArgs = {
  spaceId: Scalars["Int"];
  spaceSummary: SpaceSummaryInput;
};

export type MutationUpdateSpatialConfigurationArgs = {
  spaceId: Scalars["Int"];
  spatialConfigurations: Array<InputMaybe<SpaceSpatialConfigurationInput>>;
};

export type MutationUpdateTour3dUrlArgs = {
  spaceId: Scalars["Int"];
  tour3dUrl?: InputMaybe<Scalars["String"]>;
};

export type MutationUpdateVenueArgs = {
  id: Scalars["Int"];
  venue: VenueInput;
};

export type MutationAuthenticateGuestArgs = {
  input: AuthenticateGuestInput;
};

export type MutationBriefArgs = {
  params: BriefAttributes;
};

export type MutationCancelEventArgs = {
  UUID: Scalars["ID"];
  releaseReason: EventReleaseReason;
};

export type MutationClaimBriefArgs = {
  id: Scalars["Int"];
};

export type MutationCompleteEventArgs = {
  UUID: Scalars["ID"];
};

export type MutationCreateBusinessGuestAccountArgs = {
  input: CreateBusinessGuestAccountInput;
};

export type MutationCreateEventArgs = {
  input: CreateEventInput;
};

export type MutationCreateEventNoteArgs = {
  input: CreateEventNoteInput;
};

export type MutationCreateHostAccountArgs = {
  input: CreateHostAccountInput;
};

export type MutationCreateProposalArgs = {
  input: CreateProposalInput;
};

export type MutationCreateStandardGuestAccountArgs = {
  input: CreateStandardGuestAccountInput;
};

export type MutationDeclineInvitationArgs = {
  ID: Scalars["Int"];
  reason: InvitationDeclinedReason;
};

export type MutationDeleteEventNoteArgs = {
  input: DeleteEventNoteInput;
};

export type MutationDisqualifyBriefArgs = {
  id: Scalars["Int"];
};

export type MutationGetProposalDocumentUrlArgs = {
  eventID: Scalars["Int"];
  filename: Scalars["String"];
};

export type MutationReleaseBriefArgs = {
  id: Scalars["Int"];
};

export type MutationReleaseProposalsArgs = {
  IDs: Array<Scalars["Int"]>;
};

export type MutationRequestToBookArgs = {
  input: ReqToBookIn;
};

export type MutationResendBriefConfirmationArgs = {
  id: Scalars["Int"];
};

export type MutationResendBriefToHubspotArgs = {
  id: Scalars["Int"];
};

export type MutationResendUserToHubspotArgs = {
  contactCity: Scalars["String"];
  country: Scalars["String"];
  id: Scalars["Int"];
};

export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};

export type MutationSendInvitationsArgs = {
  eventID: Scalars["Int"];
  spaceIDs: Array<Scalars["Int"]>;
};

export type MutationTriggerPasswordResetArgs = {
  input: TriggerPasswordResetInput;
};

export type MutationUpdateEventArgs = {
  input?: InputMaybe<UpdateEventInput>;
};

export type MutationUpdateHostArgs = {
  args: UpdateHostArgs;
};

export type MutationUpdatePreferredVenuesForCompanyArgs = {
  companyID: Scalars["Int"];
  venueIDs: Array<Scalars["Int"]>;
};

export type MutationUpdateProposalArgs = {
  input: UpdateProposalInput;
};

export type NearestTransit = {
  __typename?: "NearestTransit";
  distanceKm?: Maybe<Scalars["Float"]>;
  station?: Maybe<Scalars["String"]>;
  transitType?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type Page = {
  __typename?: "Page";
  hasNextPage: Scalars["Boolean"];
  number: Scalars["Int"];
  size: Scalars["Int"];
};

export type PageInput = {
  number: Scalars["Int"];
  size: Scalars["Int"];
};

export type PreferredVenuesByCompany = {
  __typename?: "PreferredVenuesByCompany";
  company: Company;
  preferredVenues: Array<SelfServeVenue>;
};

export type Proposal = {
  __typename?: "Proposal";
  ID: Scalars["Int"];
  UUID: Scalars["ID"];
  attendees: Scalars["Int"];
  baseCostDescription: Scalars["String"];
  baseCostTotal: Scalars["Int"];
  currency: Scalars["String"];
  documents?: Maybe<Array<ProposalDocument>>;
  event: Event;
  eventID: Scalars["Int"];
  extraCostItems?: Maybe<Array<ExtraCostItem>>;
  fromDateTime: Scalars["String"];
  hasPreferredVenue: Scalars["Boolean"];
  hostID: Scalars["Int"];
  invitationID: Scalars["Int"];
  message?: Maybe<Scalars["String"]>;
  space: SelfServeSpace;
  spaceID: Scalars["Int"];
  status: ProposalStatus;
  toDateTime: Scalars["String"];
};

export type ProposalDocument = {
  __typename?: "ProposalDocument";
  ID: Scalars["Int"];
  URL: Scalars["String"];
  filename: Scalars["String"];
  s3Key: Scalars["String"];
};

export type ProposalSignedUrlData = {
  __typename?: "ProposalSignedUrlData";
  URL: Scalars["String"];
  s3Key: Scalars["String"];
};

export enum ProposalStatus {
  AwaitingDecision = "AwaitingDecision",
  Created = "Created",
  Expired = "Expired",
  Rejected = "Rejected",
  RequestedToBook = "RequestedToBook",
  SentToGuest = "SentToGuest",
}

export type Query = {
  __typename?: "Query";
  BBBE_spaces: SpaceSearch;
  _?: Maybe<Scalars["Boolean"]>;
  /** Query for AM Leads list table.  */
  amLeadsPage: LeadsPage;
  /** Query for archived leads list table.  */
  archivedLeadsPage: LeadsPage;
  /** Query for Brief by ID.  */
  brief: Brief;
  /** Query for whether a Brief qualifies for automation.  */
  briefIsAutomatable: BriefIsAutomatableResponse;
  collection: Collection;
  collections: Array<Collection>;
  getAllHostsInfo: Array<HostInfo>;
  getEvent: Event;
  getEventByUUID: Event;
  getEventPageByHost?: Maybe<EventPage>;
  getEvents?: Maybe<Array<Maybe<Event>>>;
  getEventsByHost: Array<Event>;
  getEventsByUser: Array<Event>;
  getGuestType: GuestType;
  getHostInfo: HostInfo;
  getInvitationDeclinedReasons: Array<InvitationDeclinedReason>;
  getJwt?: Maybe<Scalars["String"]>;
  getPreferredVenuesByCompanyID: Array<SelfServeVenue>;
  getPreferredVenuesByCompanyIDs: Array<PreferredVenuesByCompany>;
  getProposalsByIDs: Array<Proposal>;
  getProposalsByUUIDs: Array<Proposal>;
  getSession?: Maybe<Session>;
  getSpaceDocumentSignedInfo?: Maybe<SpaceDocumentSignedInfo>;
  getSpaceDocumentUrlFromS3Key?: Maybe<Scalars["String"]>;
  getSpacePhotoSignedInfo?: Maybe<SpacePhotoSignedInfo>;
  getSpacePhotoUrlFromS3Key?: Maybe<Scalars["String"]>;
  getStyles: Array<Style>;
  /** Query for Leads with status.  */
  leads: Array<Brief>;
  me?: Maybe<User>;
  /** Returns a selection of ranked and filtered spaces according to passed input criteria */
  rankedSpaces: Array<Maybe<RankedSpace>>;
  spaceById?: Maybe<Space>;
  spaceFacilities?: Maybe<Array<Maybe<SpaceFacility>>>;
  spaceFacility?: Maybe<SpaceFacility>;
  spaces: Array<Space>;
  spacesPage?: Maybe<SpacesPage>;
  spatialConfigurationTypes?: Maybe<Array<Maybe<Scalars["String"]>>>;
  user: User;
  userId: Scalars["Int"];
  userSpaceById?: Maybe<Space>;
  userVenueById?: Maybe<Venue>;
  userVenues?: Maybe<Array<Maybe<Venue>>>;
  userVenuesByUserIdForAdmin?: Maybe<Array<Maybe<Venue>>>;
  venueById?: Maybe<Venue>;
  venues?: Maybe<Array<Maybe<Venue>>>;
  versionInformation: VersionInformation;
};

export type QueryBbbe_SpacesArgs = {
  page?: InputMaybe<Scalars["Int"]>;
  params: SearchParamsInput;
};

export type QueryAmLeadsPageArgs = {
  filter: RegionsFilter;
  number: Scalars["Int"];
  size: Scalars["Int"];
};

export type QueryArchivedLeadsPageArgs = {
  number: Scalars["Int"];
  size: Scalars["Int"];
};

export type QueryBriefArgs = {
  id: Scalars["ID"];
};

export type QueryBriefIsAutomatableArgs = {
  briefParams: BriefAttributes;
};

export type QueryCollectionArgs = {
  id: Scalars["String"];
};

export type QueryGetAllHostsInfoArgs = {
  args?: InputMaybe<GetAllHostsInfoArgs>;
};

export type QueryGetEventArgs = {
  ID: Scalars["Int"];
};

export type QueryGetEventByUuidArgs = {
  UUID: Scalars["ID"];
};

export type QueryGetEventPageByHostArgs = {
  archived?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryGetEventsArgs = {
  filter?: InputMaybe<EventsFilter>;
};

export type QueryGetEventsByHostArgs = {
  archived?: InputMaybe<Scalars["Boolean"]>;
  limit?: InputMaybe<Scalars["Int"]>;
  offset?: InputMaybe<Scalars["Int"]>;
};

export type QueryGetEventsByUserArgs = {
  active?: InputMaybe<EventActiveArg>;
  sort?: InputMaybe<EventSortArg>;
};

export type QueryGetGuestTypeArgs = {
  country?: InputMaybe<Scalars["String"]>;
  email: Scalars["String"];
};

export type QueryGetHostInfoArgs = {
  hostID: Scalars["Int"];
};

export type QueryGetJwtArgs = {
  token?: InputMaybe<Scalars["String"]>;
};

export type QueryGetPreferredVenuesByCompanyIdArgs = {
  companyID: Scalars["Int"];
};

export type QueryGetPreferredVenuesByCompanyIDsArgs = {
  companyIDs: Array<Scalars["Int"]>;
};

export type QueryGetProposalsByIDsArgs = {
  IDs: Array<Scalars["Int"]>;
};

export type QueryGetProposalsByUuiDsArgs = {
  UUIDs: Array<Scalars["ID"]>;
};

export type QueryGetSessionArgs = {
  token?: InputMaybe<Scalars["String"]>;
};

export type QueryGetSpaceDocumentSignedInfoArgs = {
  filename: Scalars["String"];
  spaceId: Scalars["Int"];
};

export type QueryGetSpaceDocumentUrlFromS3KeyArgs = {
  s3Key: Scalars["String"];
};

export type QueryGetSpacePhotoSignedInfoArgs = {
  filename: Scalars["String"];
  spaceId: Scalars["Int"];
};

export type QueryGetSpacePhotoUrlFromS3KeyArgs = {
  s3Key: Scalars["String"];
};

export type QueryGetStylesArgs = {
  filter?: InputMaybe<StylesFiltersInput>;
};

export type QueryLeadsArgs = {
  status?: InputMaybe<Scalars["String"]>;
};

export type QueryRankedSpacesArgs = {
  input?: InputMaybe<RankedSpacesInput>;
};

export type QuerySpaceByIdArgs = {
  id: Scalars["Int"];
};

export type QuerySpaceFacilityArgs = {
  id: Scalars["Int"];
};

export type QuerySpacesArgs = {
  filter?: InputMaybe<SpaceFiltersInput>;
};

export type QuerySpacesPageArgs = {
  filter?: InputMaybe<SpaceFiltersInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<SpaceSortInput>;
};

export type QueryUserArgs = {
  id: Scalars["Int"];
};

export type QueryUserSpaceByIdArgs = {
  id: Scalars["Int"];
};

export type QueryUserVenueByIdArgs = {
  id: Scalars["Int"];
};

export type QueryUserVenuesByUserIdForAdminArgs = {
  userId: Scalars["Int"];
};

export type QueryVenueByIdArgs = {
  id: Scalars["Int"];
};

export type QueryVenuesArgs = {
  filter?: InputMaybe<VenueFiltersInput>;
};

export type RankedSpace = {
  __typename?: "RankedSpace";
  /** The distance between the brief pin and the space in metres */
  distanceToBriefMetres: Scalars["Int"];
  /** Details of which rankings were applied and the points assigned or removed by those rankings */
  rankingResult: Array<Maybe<RankedSpacesResult>>;
  /** Details of the ranked space */
  space: Space;
  /** Cumulative points after all rankings */
  totalPoints: Scalars["Int"];
};

/** Filters out spaces that do not fit inside the capacity contraints */
export type RankedSpacesCapacityFilter = {
  /** Filters out spaces that cannot fulfill the capacity of the brief */
  attendees: Scalars["Int"];
};

/** Filters out any Spaces which cannot host the requested event type(s) */
export type RankedSpacesEventTypeFilter = {
  /** The event type ID that a space must be able to host */
  eventTypeId: Scalars["Int"];
  /** True to only return Smart Book spaces */
  smartBookOnly?: InputMaybe<Scalars["Boolean"]>;
};

export type RankedSpacesFilters = {
  capacity?: InputMaybe<RankedSpacesCapacityFilter>;
  eventType?: InputMaybe<RankedSpacesEventTypeFilter>;
  location?: InputMaybe<RankedSpacesLocationFilter>;
};

/**
 * Input criteria include filters (remove spaces from consideration)
 * and rankings (assign or remove points to/from spaces);
 * after ranking the array is sorted by net ranking points,
 * where points are tied spaces are sorted by distance (closer to brief is higher)
 */
export type RankedSpacesInput = {
  /** Brief latitude and longitude */
  briefLatLon: BriefLatLon;
  /** Filters remove spaces, removed spaces are not ranked or sorted. Filters are optional but highly recommended for speed and cost purposes */
  filters?: InputMaybe<RankedSpacesFilters>;
  /** The number of spaces to be returned, the highest ranked */
  numberOfResults: Scalars["Int"];
  /** Rankings assign or remove points to/from spaces */
  rankings: RankedSpacesRankings;
};

/** Filters out any Spaces which are beyond the radius supplied */
export type RankedSpacesLocationFilter = {
  /**
   * Radius from the brief location in metres,
   * any spaces beyond this radius are filtered out
   */
  maximumRadiusMetres: Scalars["Int"];
};

export type RankedSpacesRankings = {
  /** Assigns points to a space if it has some facilities matching those that were requested */
  spaceFacilities?: InputMaybe<SpaceFacilitiesRanking>;
  /** Assigns points to a space if it is within a specified distance from a location */
  withinRadius?: InputMaybe<WithinRadiusRanking>;
};

export type RankedSpacesResult = {
  __typename?: "RankedSpacesResult";
  /** Additional details of how the points were awarded or subtracted */
  details?: Maybe<Array<Maybe<RankedSpacesResultDetails>>>;
  /** Negative points removed by the ranking (note: these are not yet implemented) */
  negativePoints?: Maybe<Scalars["Int"]>;
  /** Cumulative points after ranking */
  netPoints: Scalars["Int"];
  /** Positive points assigned by the ranking */
  positivePoints?: Maybe<Scalars["Int"]>;
  /** The name of the ranking applied */
  rankingName: Scalars["String"];
};

export type RankedSpacesResultDetails = SpaceFacilitiesRankingResultDetails;

export type RegionsFilter = {
  regions?: InputMaybe<Array<Scalars["String"]>>;
};

export type ReqToBookIn = {
  costItems: Array<CostItemQtyIn>;
  proposalID: Scalars["Int"];
};

export type ResetPasswordInput = {
  email: Scalars["String"];
  password: Scalars["String"];
  resetPasswordToken: Scalars["String"];
};

export type SearchParamsInput = {
  additionalNotes?: InputMaybe<Scalars["String"]>;
  budget: Scalars["Int"];
  capacities: Scalars["Int"];
  catering?: InputMaybe<Array<Scalars["String"]>>;
  collection?: InputMaybe<Scalars["String"]>;
  collectionName?: InputMaybe<Scalars["String"]>;
  country?: InputMaybe<Scalars["String"]>;
  currency?: InputMaybe<Scalars["String"]>;
  eventName?: InputMaybe<Scalars["String"]>;
  facilities?: InputMaybe<Array<Scalars["String"]>>;
  flexibleDates?: InputMaybe<Scalars["Boolean"]>;
  fromDate?: InputMaybe<Scalars["String"]>;
  fromTime?: InputMaybe<Scalars["String"]>;
  hostId?: InputMaybe<Scalars["String"]>;
  id?: InputMaybe<Scalars["Int"]>;
  lat: Scalars["String"];
  layouts?: InputMaybe<Scalars["String"]>;
  location: Scalars["String"];
  lon: Scalars["String"];
  public?: InputMaybe<Scalars["Boolean"]>;
  radius?: InputMaybe<Scalars["Int"]>;
  spaceId?: InputMaybe<Scalars["String"]>;
  toDate?: InputMaybe<Scalars["String"]>;
  toTime?: InputMaybe<Scalars["String"]>;
  userId?: InputMaybe<Scalars["Int"]>;
};

export type SelfServeSpace = {
  __typename?: "SelfServeSpace";
  ID?: Maybe<Scalars["Int"]>;
  description?: Maybe<Scalars["String"]>;
  hostContact: HostContact;
  spaceFeatures?: Maybe<Array<SelfServeSpaceFeature>>;
  spaceName?: Maybe<Scalars["String"]>;
  spacePhotos?: Maybe<Array<SelfServeSpacePhoto>>;
  spatialConfigurations?: Maybe<Array<SelfServeSpatialConfiguration>>;
  tour3dUrl?: Maybe<Scalars["String"]>;
  venue?: Maybe<SelfServeVenue>;
};

export type SelfServeSpaceFeature = {
  __typename?: "SelfServeSpaceFeature";
  ID?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

export type SelfServeSpacePhoto = {
  __typename?: "SelfServeSpacePhoto";
  position?: Maybe<Scalars["Int"]>;
  url?: Maybe<Scalars["String"]>;
};

export type SelfServeSpatialConfiguration = {
  __typename?: "SelfServeSpatialConfiguration";
  ID?: Maybe<Scalars["Int"]>;
  capacity?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

export type SelfServeVenue = {
  __typename?: "SelfServeVenue";
  ID?: Maybe<Scalars["Int"]>;
  addressLine1?: Maybe<Scalars["String"]>;
  addressLine2?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  latitude?: Maybe<Scalars["Float"]>;
  longitude?: Maybe<Scalars["Float"]>;
  name?: Maybe<Scalars["String"]>;
  nearestTransit?: Maybe<NearestTransit>;
  postalCode?: Maybe<Scalars["String"]>;
};

export type Session = {
  __typename?: "Session";
  jwt: Scalars["String"];
  refreshToken?: Maybe<Scalars["String"]>;
  user: User;
};

export enum SortDirection {
  Asc = "ASC",
  Desc = "DESC",
}

export type Space = {
  __typename?: "Space";
  city: Scalars["String"];
  collectionIds?: Maybe<Array<Maybe<Scalars["Int"]>>>;
  collections?: Maybe<Array<Maybe<Collection>>>;
  coordinates: SpaceCoordinates;
  country: Scalars["String"];
  dateVenueCreated: Scalars["String"];
  deleted?: Maybe<Scalars["Boolean"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  description?: Maybe<Scalars["String"]>;
  host: Host;
  id?: Maybe<Scalars["ID"]>;
  isPrivate?: Maybe<Scalars["Boolean"]>;
  lastDigitalProposalProposalDate: Scalars["String"];
  latitude: Scalars["Float"];
  location?: Maybe<Scalars["String"]>;
  longitude: Scalars["Float"];
  map?: Maybe<Array<SpaceMap>>;
  maximumSpaceCapacity: Scalars["Int"];
  minimumSpaceCapacity: Scalars["Int"];
  name: Scalars["String"];
  numberOfDigitalProposalsInvites: Scalars["Int"];
  numberOfDigitalProposalsProposals: Scalars["Int"];
  numberOfSmartBookInvites: Scalars["Int"];
  preferredCompanies: Array<Maybe<Scalars["String"]>>;
  publishedAt?: Maybe<Scalars["DateTime"]>;
  rejectedAt?: Maybe<Scalars["DateTime"]>;
  smartBookEventTypes: Array<Maybe<Scalars["Int"]>>;
  spaceDocuments?: Maybe<Array<Maybe<SpaceDocument>>>;
  spaceFacilities?: Maybe<Array<Maybe<SpaceFacility>>>;
  spaceName?: Maybe<Scalars["String"]>;
  spacePhotos: Array<SpacePhoto>;
  spatialConfigurations?: Maybe<Array<Maybe<SpatialConfiguration>>>;
  status?: Maybe<SpaceStatus>;
  styleIds: Array<StyleId>;
  styles?: Maybe<Array<Style>>;
  submittedAt?: Maybe<Scalars["DateTime"]>;
  tour3dUrl?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars["Int"]>;
  venue?: Maybe<Venue>;
  venueId?: Maybe<Scalars["Int"]>;
  venueName?: Maybe<Scalars["String"]>;
};

export type SpaceCoordinates = {
  __typename?: "SpaceCoordinates";
  lat: Scalars["Float"];
  lng: Scalars["Float"];
};

export type SpaceDocument = {
  __typename?: "SpaceDocument";
  caption?: Maybe<Scalars["String"]>;
  documentType?: Maybe<SpaceDocumentType>;
  filename?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["Int"]>;
  position?: Maybe<Scalars["Int"]>;
  s3Key?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
};

export type SpaceDocumentInput = {
  caption?: InputMaybe<Scalars["String"]>;
  documentType?: InputMaybe<SpaceDocumentType>;
  filename: Scalars["String"];
  s3Key: Scalars["String"];
};

export type SpaceDocumentSignedInfo = {
  __typename?: "SpaceDocumentSignedInfo";
  s3Key?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
};

export enum SpaceDocumentType {
  Facilities = "facilities",
  FloorPlans = "floor_plans",
  Generic = "generic",
  Menu = "menu",
  TermsAndConditions = "terms_and_conditions",
}

export type SpaceFacilitiesRanking = {
  /** Number of positive points to be assigned if a space has a matching facility */
  positivePoints: Scalars["Int"];
  /** Space facility IDs to be ranked */
  spaceFacilityIds: Array<Scalars["Int"]>;
};

export type SpaceFacilitiesRankingResultDetails = {
  __typename?: "SpaceFacilitiesRankingResultDetails";
  /** Number of positive points awarded as a result of matching */
  positivePoints: Scalars["Int"];
  /** Space facility which matched */
  spaceFacility: SpaceFacility;
};

/** Consistent, business-defined properties of spaces that users can request for their events, such as 'natural light', 'parking facilities', etc. */
export type SpaceFacility = {
  __typename?: "SpaceFacility";
  facilityCategory?: Maybe<FacilityCategory>;
  facilityCategoryId?: Maybe<Scalars["Int"]>;
  icon?: Maybe<Scalars["String"]>;
  id: Scalars["Int"];
  name: Scalars["String"];
  position?: Maybe<Scalars["Int"]>;
};

export type SpaceFeature = {
  __typename?: "SpaceFeature";
  featureCategory?: Maybe<FeatureCategory>;
  featureCategoryId?: Maybe<Scalars["Int"]>;
  icon?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["Int"]>;
};

export type SpaceFiltersInput = {
  collectionIds?: InputMaybe<Array<Scalars["Int"]>>;
  countries?: InputMaybe<Array<InputMaybe<VenueCountry>>>;
  deleted?: InputMaybe<Scalars["Boolean"]>;
  geolocation?: InputMaybe<GeolocationFilterInput>;
  ids?: InputMaybe<Array<Scalars["Int"]>>;
  published?: InputMaybe<Scalars["Boolean"]>;
  rejected?: InputMaybe<Scalars["Boolean"]>;
  searchTerms?: InputMaybe<Scalars["String"]>;
  submitted?: InputMaybe<Scalars["Boolean"]>;
  userId?: InputMaybe<Scalars["Int"]>;
  userIds?: InputMaybe<Array<Scalars["Int"]>>;
};

export type SpaceMap = {
  __typename?: "SpaceMap";
  coordinates: SpaceCoordinates;
  id: Scalars["ID"];
  location?: Maybe<Scalars["String"]>;
  onPage: Scalars["Boolean"];
};

export type SpacePhoto = {
  __typename?: "SpacePhoto";
  detail: Scalars["String"];
  filename?: Maybe<Scalars["String"]>;
  filenameProcessing?: Maybe<Scalars["Boolean"]>;
  id: Scalars["ID"];
  listings: Scalars["String"];
  position: Scalars["Int"];
  s3Key?: Maybe<Scalars["String"]>;
  squareThumb: Scalars["String"];
  thumb: Scalars["String"];
  url: Scalars["String"];
};

export type SpacePhotoInput = {
  filename: Scalars["String"];
  s3Key: Scalars["String"];
};

export type SpacePhotoSignedInfo = {
  __typename?: "SpacePhotoSignedInfo";
  s3Key?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
};

export type SpaceSearch = {
  __typename?: "SpaceSearch";
  listView: Array<Space>;
  mapView: Array<SpaceMap>;
};

export enum SpaceSortField {
  Id = "id",
  PublishedAt = "publishedAt",
  RejectedAt = "rejectedAt",
  SubmittedAt = "submittedAt",
}

export type SpaceSortInput = {
  direction: SortDirection;
  field: SpaceSortField;
};

export type SpaceSpatialConfigurationInput = {
  capacity: Scalars["Int"];
  name: Scalars["String"];
};

export enum SpaceStatus {
  Complete = "complete",
  Overview = "overview",
  Published = "published",
  Reviewed = "reviewed",
  UnderReview = "under_review",
}

export type SpaceSummaryInput = {
  description: Scalars["String"];
  name: Scalars["String"];
};

export type SpacesPage = {
  __typename?: "SpacesPage";
  page?: Maybe<Page>;
  rows?: Maybe<Array<Maybe<Space>>>;
  totalPages?: Maybe<Scalars["Int"]>;
  totalRows?: Maybe<Scalars["Int"]>;
};

export type SpatialConfiguration = {
  __typename?: "SpatialConfiguration";
  capacity?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["Int"]>;
  name?: Maybe<Scalars["String"]>;
};

export type Style = {
  __typename?: "Style";
  emoji?: Maybe<Scalars["String"]>;
  id?: Maybe<StyleId>;
  label?: Maybe<Scalars["String"]>;
};

export enum StyleId {
  BlankCanvas = "blank_canvas",
  Casual = "casual",
  Formal = "formal",
  Fun = "fun",
  Industrial = "industrial",
  Lively = "lively",
  Luxury = "luxury",
  Modern = "modern",
  Professional = "professional",
  Quiet = "quiet",
  Quirky = "quirky",
  Simple = "simple",
  Social = "social",
  Traditional = "traditional",
}

export type StylesFiltersInput = {
  id?: InputMaybe<StyleId>;
  ids?: InputMaybe<Array<InputMaybe<StyleId>>>;
};

export type TriggerPasswordResetInput = {
  email: Scalars["String"];
};

export type UpdateEventInput = {
  UUID: Scalars["ID"];
  accountManagerId?: InputMaybe<Scalars["Int"]>;
  actualEventMgmtFee?: InputMaybe<Scalars["Int"]>;
  additionalNotes?: InputMaybe<Scalars["String"]>;
  attendees: Scalars["Int"];
  budget: Scalars["Int"];
  cateringNeeds?: InputMaybe<Scalars["String"]>;
  commissionPerc?: InputMaybe<Scalars["Float"]>;
  currency: Scalars["String"];
  decisionDate?: InputMaybe<Scalars["String"]>;
  estimatedEventMgmtFee?: InputMaybe<Scalars["Int"]>;
  eventTypeID: Scalars["Int"];
  fromDateTime: Scalars["String"];
  lat: Scalars["String"];
  layoutID: Scalars["String"];
  location: Scalars["String"];
  lon: Scalars["String"];
  name: Scalars["String"];
  processingFeePerc?: InputMaybe<Scalars["Float"]>;
  spaceFacilityIDs: Array<Scalars["Int"]>;
  styleIDs?: InputMaybe<Array<Scalars["String"]>>;
  toDateTime: Scalars["String"];
};

export type UpdateHostArgs = {
  addEventTypeIDs: Array<Scalars["Int"]>;
  hostID: Scalars["Int"];
  removeEventTypeIDs: Array<Scalars["Int"]>;
};

export type UpdateProposalInput = {
  UUID: Scalars["ID"];
  attendees: Scalars["Int"];
  baseCostDescription: Scalars["String"];
  baseCostTotal: Scalars["Int"];
  currency: Scalars["String"];
  documentFilePaths?: InputMaybe<Array<Scalars["String"]>>;
  extraCostItems?: InputMaybe<Array<ExtraCostItemInput>>;
  fromDateTime: Scalars["String"];
  message?: InputMaybe<Scalars["String"]>;
  toDateTime: Scalars["String"];
};

export type User = {
  __typename?: "User";
  ID: Scalars["Int"];
  avatar: Scalars["String"];
  company?: Maybe<Company>;
  companyID?: Maybe<Scalars["Int"]>;
  companyLogo?: Maybe<Scalars["String"]>;
  companyLogoUrl?: Maybe<Scalars["String"]>;
  companyName?: Maybe<Scalars["String"]>;
  contactNumber?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  firstName: Scalars["String"];
  id: Scalars["Int"];
  isPowerHost: Scalars["Boolean"];
  jobTitle?: Maybe<Scalars["String"]>;
  lastName: Scalars["String"];
  phoneNumber?: Maybe<Scalars["String"]>;
  regions: Array<Scalars["String"]>;
  roles: Array<Scalars["String"]>;
  widgetBacklinkMandatory?: Maybe<Scalars["Boolean"]>;
};

export type Venue = {
  __typename?: "Venue";
  addressLine1?: Maybe<Scalars["String"]>;
  addressLine2?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  deleted?: Maybe<Scalars["Boolean"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
  id?: Maybe<Scalars["Int"]>;
  latitude?: Maybe<Scalars["Float"]>;
  longitude?: Maybe<Scalars["Float"]>;
  name?: Maybe<Scalars["String"]>;
  postalCode?: Maybe<Scalars["String"]>;
  spaces?: Maybe<Array<Maybe<Space>>>;
  state?: Maybe<Scalars["String"]>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars["Int"]>;
};

export enum VenueCountry {
  Au = "AU",
  De = "DE",
  Es = "ES",
  Fr = "FR",
  Gb = "GB",
  Ie = "IE",
  It = "IT",
  Nl = "NL",
  Uk = "UK",
}

export type VenueFiltersInput = {
  geolocation?: InputMaybe<GeolocationFilterInput>;
  ids?: InputMaybe<Array<Scalars["Int"]>>;
  publishedSpacesOnly?: InputMaybe<Scalars["Boolean"]>;
  userIds?: InputMaybe<Array<Scalars["Int"]>>;
  venueNameLike?: InputMaybe<Scalars["String"]>;
};

export type VenueInput = {
  addressLine1: Scalars["String"];
  addressLine2?: InputMaybe<Scalars["String"]>;
  city: Scalars["String"];
  country: Scalars["String"];
  latitude: Scalars["Float"];
  longitude: Scalars["Float"];
  name: Scalars["String"];
  postalCode: Scalars["String"];
  state: Scalars["String"];
};

export type VersionInformation = {
  __typename?: "VersionInformation";
  name: Scalars["String"];
  semver: Scalars["String"];
};

export type WithinRadiusRanking = {
  /** Number of positive points to be assigned if a space is within the specified radius */
  positivePoints: Scalars["Int"];
  /** Distance from the brief location in metres */
  withinRadiusMetres: Scalars["Int"];
};
